import React, { useMemo } from 'react'
import { ICycleSession, IModuleSessionDistribution } from '../../../../types/cycleSession'
import './styles.css'
import StudyDistributionChart from 'pages/Planning/components/configuration/summary/StudyDistributionChart'

interface SessionsChartProps {
  sessions: ICycleSession[]
  totalHours: number
  isDarkMode?: boolean
}

/**
 * Componente que exibe gráfico de rosca com distribuição das sessões por disciplina
 */
const SessionsChart: React.FC<SessionsChartProps> = ({
  sessions,
  totalHours,
  isDarkMode = false,
}) => {
  // Calcula os segmentos do círculo
  // const segments = useMemo(() => {
  //   let cumulativePercentage = 0

  //   return distribution.map((item) => {
  //     const percentage = (item.totalHours / totalHours) * 100
  //     const startAngle = (cumulativePercentage / 100) * 360
  //     const endAngle = startAngle + (percentage / 100) * 360

  //     cumulativePercentage += percentage

  //     return {
  //       ...item,
  //       percentage: percentage.toFixed(1),
  //       startAngle,
  //       endAngle,
  //     }
  //   })
  // }, [distribution, totalHours])

  // Cria os paths SVG para cada segmento
  const createArcPath = (startAngle: number, endAngle: number) => {
    const startAngleRad = ((startAngle - 90) * Math.PI) / 180
    const endAngleRad = ((endAngle - 90) * Math.PI) / 180

    const radius = 80
    const innerRadius = 55

    const x1 = 100 + radius * Math.cos(startAngleRad)
    const y1 = 100 + radius * Math.sin(startAngleRad)
    const x2 = 100 + radius * Math.cos(endAngleRad)
    const y2 = 100 + radius * Math.sin(endAngleRad)

    const x3 = 100 + innerRadius * Math.cos(endAngleRad)
    const y3 = 100 + innerRadius * Math.sin(endAngleRad)
    const x4 = 100 + innerRadius * Math.cos(startAngleRad)
    const y4 = 100 + innerRadius * Math.sin(startAngleRad)

    const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0

    return `
      M ${x1} ${y1}
      A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}
      L ${x3} ${y3}
      A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${x4} ${y4}
      Z
    `
  }

  return (
    <div className="cycle-sessions-chart span-2" data-tour="dashboard-sessions-chart">
      <h3 className="cycle-chart-title">Distribuição das sessões</h3>

      <div className="cycle-chart-content">
        <StudyDistributionChart
          sessions={sessions}
          totalHours={totalHours}
          isDarkMode={isDarkMode}
          addProgressRing={true}
        />
        {/* <svg viewBox="0 0 200 200" className="cycle-donut-chart">
          {segments.map((segment, index) => (
            <path
              key={segment.moduleId}
              d={createArcPath(segment.startAngle, segment.endAngle)}
              fill={segment.color}
              className="cycle-donut-segment"
            />
          ))}
          <circle cx="100" cy="100" r="55" fill="var(--config-bg)" />
          <text
            x="100"
            y="95"
            textAnchor="middle"
            className="cycle-donut-center-text"
            fontSize="24"
            fontWeight="700"
          >
            {totalHours.toFixed(1)}h
          </text>
          <text
            x="100"
            y="115"
            textAnchor="middle"
            className="cycle-donut-center-label"
            fontSize="12"
          >
            Total Semanal
          </text>
        </svg>

        <div className="cycle-chart-legend">
          {distribution.map((item) => (
            <div key={item.moduleId} className="cycle-legend-item">
              <div className="cycle-legend-color" style={{ backgroundColor: item.color }} />
              <div className="cycle-legend-details">
                <div className="cycle-legend-subject">{item.subject}</div>
                <div className="cycle-legend-hours">
                  {item.totalHours.toFixed(1)}h · {item.sessionsCount} sessões
                </div>
              </div>
            </div>
          ))}
        </div> */}
      </div>
    </div>
  )
}

export default SessionsChart
